import { useState, useRef } from 'react';
import ReCAPTCHA from "react-google-recaptcha"
import { toast } from 'react-toastify';
import { mask } from 'remask';
//
import apiPlay from '../../services/apiPlay';
//
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import LoadingButton from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
//
import { IoDocumentText, IoLogoAppleAppstore, IoLogoGooglePlaystore } from 'react-icons/io5'

export default function Faturas() {

    const [currentPage, setCurrentPage] = useState(1);

    const captchaRef = useRef(null);
    const [isCaptchaDone, setIsCaptchaDone] = useState(false);

    const [loadingFaturas, setLoadingFaturas] = useState(false);
    const [cpf, setCpf] = useState('');
    const [listaFaturas, setListaFaturas] = useState([]);

    function buscaFaturas(e) {
        e.preventDefault()

        captchaRef.current.reset();

        if(cpf.length > 11){
            window.location.replace("https://operadora.app.br/#/");
            return;
        }

        setLoadingFaturas(true);

        let dados = {
            cpf: cpf,
        }

        apiPlay.post('/consultafatura', dados)
            .then((response) => {
                setListaFaturas(response.data);
                setLoadingFaturas(false);
                setCurrentPage(2);

            })
            .catch((error) => {
                console.log(error);

                if (error.response.status === 500) {
                    setLoadingFaturas(false);
                    toast.error("CPF ou CNPJ inexistente!");
                    return;
                }

                setLoadingFaturas(false);
                toast.error("Erro ao buscar faturas!");
            })
    }

    return (
        <Container
            component="section"
            maxWidth="xs"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}
        >
            {currentPage === 1 &&
                <FormFaturas
                    {...{
                        loadingFaturas,
                        cpf,
                        setCpf,
                        buscaFaturas,
                        captchaRef,
                        isCaptchaDone,
                        setIsCaptchaDone
                    }}
                />
            }

            {currentPage === 2 &&
                <ListaFaturas {...{ listaFaturas }} />
            }

            <Typography
                variant="caption"
                color="text.secondary"
                align="center"
                mt={4}
                mb={8}
            >
                Copyright © PlayMóvel TELEFONIA MOVEL CELULAR LTDA {new Date().getFullYear()}
            </Typography>

        </Container>
    )
}

function FormFaturas({
    loadingFaturas,
    cpf,
    setCpf,
    buscaFaturas,
    captchaRef,
    isCaptchaDone,
    setIsCaptchaDone
}) {

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mt: '50%',
            }}
        >
            <Typography
                variant='h5'
                fontWeight={600}
                textAlign='center'
            >
                Portal de Faturas
            </Typography>

            <Box
                component="form"
                onSubmit={buscaFaturas}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                    mt: 1,
                }}
            >
                <TextField
                    id='cpf'
                    label='CPF/CNPJ'
                    placeholder='000.000.000-00 ou 00.000.000/0000-00'
                    value={mask(cpf, ['999.999.999-99','99.999.999/9999-99'])}
                    onChange={e => setCpf(mask(e.target.value, ['99999999999', '99999999999999']))}
                    margin='normal'
                    fullWidth
                    autoComplete="cpf"
                    required
                    autoFocus
                />

                <LoadingButton
                    type="submit"
                    fullWidth
                    variant="contained"
                    size='large'
                    sx={{ mt: 3, mb: 2 }}
                    loading={loadingFaturas}
                    disabled={!isCaptchaDone}
                >
                    Buscar
                </LoadingButton>

                <ReCAPTCHA
                    tabindex={1}
                    ref={captchaRef}
                    sitekey={'6Lc0vOMhAAAAAGv6a-wUd_btQIFNG4yinaKKnxDf'}
                    onChange={()=>{setIsCaptchaDone(true)}}
                />

            </Box>

        </Box>
    )
}

function ListaFaturas({ listaFaturas }) {

    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                mt: '50%',
            }}
        >
            <Typography
                variant='h5'
                fontWeight={600}
                textAlign='center'
            >
                Faturas | {listaFaturas[0]?.parceiro}
            </Typography>

            <Paper
                sx={{
                    width: '100%',
                    p: 2,
                    mt: 2,
                }}
            >

                {listaFaturas[0].invoiceurl === '' &&
                    <Typography
                        variant='h5'
                        fontWeight={600}
                        textAlign='center'
                    >
                        Suas faturas estão em dia!
                    </Typography>
                }

                {listaFaturas[0].invoiceurl !== '' &&
                    <List
                        sx={{ width: '100%' }}
                    >
                        {listaFaturas.map((item, index) => {
                            return (
                                <ListItemButton
                                    key={index}
                                    component='a'
                                    href={`https://fatura.operadora.app.br/?payid=${item.paymentasaasid}`}
                                    target='_blank'
                                    sx={{ borderBottom: '1px solid', borderBottomColor: 'divider' }}
                                >
                                    <ListItemAvatar>
                                        <Avatar
                                            sx={!item.msisdn
                                                ? { bgcolor: 'warning.main' }
                                                : { bgcolor: 'info.main' }
                                            }
                                        >
                                            <IoDocumentText />
                                        </Avatar>
                                    </ListItemAvatar>

                                    <ListItemText
                                        primary={item.msisdn
                                            ? mask(item.msisdn.slice(2), ['(99) 99999-9999'])
                                            : 'Ativação Pendente'
                                        }
                                        secondary={
                                            `Vencimento: ${item.bundleexpiry?.replaceAll('-', '/') || '##-##-####'}`
                                        }
                                    />
                                </ListItemButton>
                            )
                        })}
                    </List>
                }
            </Paper>

            <Typography variant="body2" color="text.secondary" align="center" mt={2}>
                Ainda não baixou o app?
            </Typography>

            <Box mt={1}>
                <IconButton
                    component='a'
                    aria-label="Baixar Google Play Store"
                    color='success'
                    href={listaFaturas[0].link_playstore || ''}
                    target='_blank'
                >
                    <IoLogoGooglePlaystore />
                </IconButton>

                <IconButton
                    component='a'
                    aria-label="Baixar Apple App Store"
                    color='info'
                    href={listaFaturas[0].link_appstore || ''}
                    target='_blank'
                >
                    <IoLogoAppleAppstore />
                </IconButton>
            </Box>

            <Typography variant="body2" color="text.secondary" align="center" mt={1}>
                {'Dúvidas? '}
                <Link
                    color='inherit'
                    href={listaFaturas[0].link_chat || ''}
                    target='_blank'
                >
                    Fale Conosco
                </Link>
            </Typography>
        </Box>
    )
}
